import getRootDomain from 'common/get-root-domain';
import getStepupDomain from 'common/get-stepup-domain';

export const ROOT_DOMAIN = getRootDomain();
export const THM_ORIGIN = 'https://thm.visa.com';
export const STEPUP_DOMAIN = getStepupDomain();
